<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <router-link tag="button" :to="{name: 'profiles.create'}" class="btn btn-info">
                    <span class="btn-label">
                        <i class="material-icons">add</i>
                    </span>
                    Novo
                </router-link>
            </div>
        </div>
        <br />
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header card-header-icon card-header-rose">
                        <div class="card-icon">
                            <i class="material-icons">list</i>
                        </div>
                        <h4 class="card-title ">Lista</h4>
                    </div>
                    <div class="card-body">
                        <div class="table-responsive">
                            <table class="table">
                                <thead>
                                    <tr>
                                        <th class="text-center">#</th>
                                        <th>Nome</th>
                                        <th>Tipo</th>
                                        <th class="text-right">Ações</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr 
                                        v-show="items.length > 0"
                                        v-for="iterator in items" 
                                        :key="iterator.id">
                                        <td class="text-center">{{ iterator.id }}</td>
                                        <td>{{ iterator.name }}</td>
                                        <td>{{ iterator.type_profile ? iterator.type_profile.name : null }}</td>
                                        <td class="td-actions text-right">
                                <b-button-group>
                                    <router-link data-original-title title="Comissões do Perfil" class="btn btn-block btn-sm btn-outline-primary" tag="button" :to="{'name': 'profiles.administrators.index', params: { 'id' : iterator.id }}">
                                                 <i class="material-icons">attach_money</i>
                                    </router-link>
                                    <router-link data-original-title title="Editar Perfil" class="btn btn-block btn-sm btn-outline-success" tag="button" :to="{'name': 'profiles.edit', params: { 'id' : iterator.id }}">
                                                 <i class="material-icons">edit</i>
                                    </router-link>
                                    <b-button title="Excluir" class="btn btn-danger btn-link" v-on:click="remove(iterator.id)">
                                        <i class="material-icons">close</i>
                                    </b-button>
                                </b-button-group>
                                </td>
                                </tr>
                                <tr v-show="items.length==0">
                                    <td colspan="3">Nenhum perfil encontrado!</td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        computed: {
            items() {
                return this.$store.state.profiles.itens;
            }
        },
        created: function () {
            if (this.$store.state.profiles.itens.length == 0) {
                this.getData();
            }
        },
        methods: {
            async getData() {
                var self = this;

                self.$root.$emit('onLoading');

                const response = self.$store.dispatch('profiles/all');

                response.then(function () {
                    self.$root.$emit('onLoading');
                });

                response.catch(function () {
                    self.$root.$emit('onLoading');
                });
            },
            remove: function (_item) {
                var self = this;

                self.$dialog.confirm('Deseja realmente remover o perfil ' + _item + '?')
                        .then(function () {
                            self.$root.$emit('onLoading');

                            const response = self.$store.dispatch('profiles/rem', {id: _item});

                            response.then(function () {
                                self.$root.$emit('onLoading');
                                self.$notify.success("Perfil excluído com sucesso!");
                                self.getData();
                            });

                            response.catch(function () {
                                self.$root.$emit('onLoading');
                                self.$notify.danger("Não foi possível excluir o perfil!");
                            });
                        });
            }
        }
    }
</script>
